export type VisitorPaymentMode = "direct" | "annual_settlement";

export interface VisitorPriceLine {
  rule_type: string;
  article_id: string;
  article_number: string;
  article_name: string;
  quantity: string;
  unit_price: string;
  line_subtotal: string;
  tax_rate_percent: string;
  tax_amount: string;
  line_total: string;
}

export interface VisitorPriceQuote {
  lines: VisitorPriceLine[];
  subtotal: string;
  tax_amount: string;
  total: string;
}

export interface VisitorRegistration {
  id: string;
  contract_id: string;
  visit_date: string;
  adults: number;
  children: number;
  extra_cars: number;
  payment_mode: VisitorPaymentMode;
  invoice_id: string | null;
  subtotal: string;
  total_amount: string;
  notes: string | null;
  created_at: string;
  guest_name?: string | null;
  pitch_code?: string | null;
  invoice_number?: string | null;
}

export interface PermanentContract {
  id: string;
  pitch_code: string;
  contract_type: "permanent";
}

export const VISITOR_PAYMENT_MODE_OPTIONS: {
  value: VisitorPaymentMode;
  label: string;
  description: string;
}[] = [
  {
    value: "direct",
    label: "Sofort bezahlen",
    description: "Rechnung wird erstellt. Bitte zahlen Sie an der Rezeption.",
  },
  {
    value: "annual_settlement",
    label: "Jahresendabrechnung",
    description: "Gebühren werden auf Ihre Jahresendabrechnung gebucht.",
  },
];

const CHARGE_RULE_LABELS: Record<string, string> = {
  visitor_adult: "Besucher Erwachsene",
  visitor_child: "Besucher Kinder",
  visitor_extra_car: "Zusätzliche Autos",
};

export function chargeRuleLabel(ruleType: string): string {
  return CHARGE_RULE_LABELS[ruleType] ?? ruleType;
}

export function visitorPaymentModeLabel(mode: VisitorPaymentMode): string {
  return VISITOR_PAYMENT_MODE_OPTIONS.find((o) => o.value === mode)?.label ?? mode;
}
